import { createRouteRef } from '@backstage/core-plugin-api';

export const manifestoptionRouteRef = createRouteRef({
  id: 'manifest-options',
});
export const rootRouteRef = createRouteRef({
  id: 'service-creator',
});
export const environmentRouteRef = createRouteRef({
  id: 'environment-variables',
});
export const previewRouteRef = createRouteRef({
  id: 'preview',
});
export const gatewayRouteRef = createRouteRef({
  id: 'gateway-manifest',
});
export const gatewayPreviewRouteRef = createRouteRef({
  id: 'gateway-preview',
});
export const httpRouteRef = createRouteRef({
  id: 'http-route',
});
export const previewHttpRouteRef = createRouteRef({
  id: 'preview-http-route',
});
export const cronJobGeneratorRouteRef = createRouteRef({
  id: 'cron-job-generator',
});
export const CronJobEnvironmentVariablesRouteRef = createRouteRef({
  id: 'cron-job-environment-variables',
});
export const CronJobPreviewRouteRef = createRouteRef({
  id: 'cron-job-preview',
});
